import { StatusChipVariant } from './status-chip.types';
import styles from './status-chip.module.scss';
import Icon from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { chipIcon } from './status-chip.constants';
import clsx from 'clsx';

interface StatusChipProps {
  variant?: StatusChipVariant;
  className?: string;
}

export default function StatusChip({ variant = 'info', className }: StatusChipProps) {
  const { t } = useTranslation('common');

  return (
    <div
      className={clsx(
        className,
        styles.statusChipContainer,
        styles[`statusChipContainer-${variant}`]
      )}
    >
      <span className={styles[`statusChip-${variant}`]}>
        <Icon component={chipIcon[variant]} />
      </span>
      <span className={`${styles[`statusChip-${variant}`]} ${styles.statusChipText}`}>
        {t(`statusChip.${variant}`)}
      </span>
    </div>
  );
}
